import { Box, HStack } from "@chakra-ui/react";
import SettingsDescription from "../elements/SettingsDescription";
import SettingsHeader from "../elements/SettingsHeader";

export default function NotificationSettings() {
  return (
    <Box>
      <SettingsHeader title="Notification" />
      <SettingsDescription text="Manage your notification settings for activity." />
      <HStack spacing="40px" alignItems="top"></HStack>
    </Box>
  );
}
